export const UPDATE_IS_MOBILE_SIZE = "update-is-mobile-size";
export const UPDATE_DEVICE_TYPE = "update-device-type";
export const UPDATE_LOCATION = "update-location";
export const UPDATE_HISTORY = "update-history";
export const UPDATE_WINDOW_WIDTH = "update-window-width";
export const UPDATE_WINDOW_HEIGHT = "update-window-height";
export const UPDATE_TOOL_BAR = "alert-update-tool-bar";
export const TOGGLE_SIDEBAR = "toggle-sidebar";

export const UPDATE_PROFILE_DATA = "update-profile-data";



// WEBPACK FOOTER //
// ./src/actions/global/types.ts